import React from 'react'

import { useTranslation } from '../../../../utils/providers'
import { trackProductListFilterChange } from '../../../../utils/Alphapet/tracking'
import { MultiCheckbox } from '../../Form'

export default function MultiSelectFilter({
  id,
  label,
  values,
  selectedValues,
  categoryUrls,
  searchData,
}) {
  const { t } = useTranslation()

  const handleChange = (e) => {
    // No submit until save button is hit
    if (e?.target) {
      trackProductListFilterChange(
        e.target.value,
        categoryUrls,
        searchData,
        e.target.checked
      )
    }
  }

  const options = Object.values(values)
    .filter(({ count }) => count > 0)
    .sort((a, b) => a.position > b.position)
    .map(({ key }) => ({
      label: key,
      value: key,
    }))

  return (
    <MultiCheckbox
      onChange={handleChange}
      data={{ name: id, value: selectedValues }}
      options={options}
      labelClassName="mb-0"
      legend={t('PRODUCT_LIST_FILTER_LABEL')(label)}
      legendClassName="sr-only"
    />
  )
}
